import React from "react";
import Footer from "../component/Footer";

function paneloSign() {
  return (
    <div className="Solution">
      <main className="font-nunito">
        <section className="pt-16">
          <div className="flex justify-center items-center w-full relative">
            <picture class="jumbotron-picture ">
              <source
                className="w-full max-h-max"
                media="(max-width: 767px)"
                srcset="./img/mobile-img.jpg"
              />
              <source
                className="w-full max-h-max"
                media="(min-width: 768px)"
                srcset="./img/solutionjumbo.png"
              />
              <img
                className="w-full max-h-max"
                src="./img/solutionjumbo.png"
                alt="Responsive jumbotron Image"
              />
            </picture>
            <div
              className="w-full
             flex flex-col m-auto justify-center items-center absolute top-0 bottom-0 overflow-y-hidden"
            >
              <h1 className="text-white text-2xl md:text-5xl text-center font-secular leading-relaxed">
                PANELO VISION <br /> CREATE YOUR FIRST ADS <br /> WITH US NOW{" "}
              </h1>
              <button className="text-white bg-main-color mt-5 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                <a href="#">Free Trial</a>
              </button>
            </div>
          </div>
        </section>
        {/* Jumbotron Section End Here */}

        {/* Cloud Base Digital Start Here */}
        <section>
          <h2 className="text-black text-3xl lg:text-4xl pt-6 md:pt-11 font-bold text-center">
            PANELO SIGN
          </h2>
          <h3 className="text-center font-bold lg:font-normal text-lg lg:text-3xl mt-4">
            Cloud based Digital Signage Solution
          </h3>
          <div className="lg:px-32 px-6 py-10">
            <p className="text-justify font-poppins">
              Panelo Sign provides one-stop digital signage solution, through a
              combination of displays, media player, a simple-to-use software
              empowered by Artificial Intelligent with wide range of valuable
              tools for your business. Comparing with others that the solution
              exclusively focusing on hardware, Panelo Sign integrates both
              between software and hardware for optimal efficiency and user
              experience offering real-time, flexible, scalable solutions for
              customers – accommodating digital signage needs of all customer
              types and sizes. Our platform is meant to easily adjust to the
              changing signage needs of your business.
            </p>
            <div className="flex flex-col items-center justify-center lg:flex-row lg:justify-around mt-12">
              <div className="lg:w-3/5">
                <iframe
                  className="shadow-lg w-full lg:h-72"
                  src="https://www.youtube.com/embed/yF8nZJNn6z8"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="flex flex-col justify-center items-center">
                <h2 className="text-gray-400 text-2xl lg:text-4xl pt-6 md:pt-11 font-bold text-center">
                  THE BEST DIGITAL SIGNAGE SOFTWARE
                </h2>
                <button className="text-white bg-main-color mt-5 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Free Trial Now</a>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-11">
          <h2 className="text-black text-3xl lg:text-4xl pt-6 md:pt-11 font-bold text-center">
            WHY PANELO SIGN?
          </h2>

          <div className="flex flex-col lg:flex-row justify-center p-4 lg:p-20 lg:py-2 lg:pt-16 lg:px-28">
            <div className="p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/cloud.png"
                  width="130"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color text-center mt-4">
                  Cloud Digital Signage System
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Powered by Amazon Web Service, we provide reliable, easy to
                  use, fast and secure cloud digital signage system
                </p>
              </div>
            </div>
            <div className=" p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/tablet.png"
                  width="130"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color text-center mt-4">
                  Layout builder with hundreds of template
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Create your own layout or use the templates, hundreds of
                  templates from menuboad, education, retailshop and many more.
                  Create and publish your content within 5 minutes
                </p>
              </div>
            </div>
            <div className=" p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/responsive.png"
                  width="130"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color text-center mt-4">
                  Web and Mobile Apps CMS
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Simple, intuitive, access anywhere with any device. Our mobile
                  apps save your time and money to manage the display​
                </p>
              </div>
            </div>
            <div className="p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/chip.png"
                  width="130"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color text-center mt-4">
                  Hardware Agnostic
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Digital signage should be the content and the messages, not
                  the display brand, its should run in any device regardless the
                  OS or brand. Panelo Sign support any device with Android,
                  Windows,Tizen or LG WebOS system. ​
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row justify-center p-4 lg:py-0 lg:px-28">
            <div className="p-5 lg:w-4/12 ">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/graphic-tablet.png"
                  width="130"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color text-center mt-4">
                  Adaptive Schedule
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Your campaign should be not limited by the time, playlist,
                  location and easy to manage. Adjust schedule from seconds to
                  years with capability to put intercept content when needed
                  without changing the schedule.
                </p>
              </div>
            </div>
            <div className="p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/printer.png"
                  width="130"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color text-center mt-4">
                  Proof of play report
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  The ROI makes easy to calculate, Panelo Sign provide complete
                  play report about the media, layout, device and location.
                </p>
              </div>
            </div>
            <div className="p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/swipe-right.png"
                  width="130"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color text-center mt-4">
                  Support touchscreen display
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  When you need interactive display, Panelo Sign support
                  touchscreen interactive with UI builder to make the interface
                  fast and easy.
                </p>
              </div>
            </div>
            <div className="p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/server.png"
                  width="130"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color text-center mt-4">
                  Integration and Custom Solution
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Connect to IoT, Sensor or other application to show the data,
                  make your display show real time data automatically without
                  touching the content.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Our Solution Section End Here */}

        {/* Hardware Section Start Here */}
        <section>
          <h2 className="text-black text-3xl lg:text-4xl pt-16 mb-5 font-bold text-center">
            FEATURES
          </h2>

          <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:px-28">
            <div className="shadow-lg hover:shadow-xl rounded-md lg:w-4/12 p-4 mx-6 mb-9">
              <div className="font-poppins">
                <ul className="list-disc pl-6">
                  <li className="border-b py-2">Centralize Cloud CMS</li>
                  <li className="border-b py-2">
                    Web and Mobile Apps Management
                  </li>
                  <li className="border-b py-2">Cloud and Local Storage</li>
                  <li className="border-b py-2">Work offline</li>
                  <li className="border-b py-2">Free layout templates</li>
                  <li className="border-b py-2">
                    Custom layout with layout builder
                  </li>
                  <li className="border-b py-2">Multiple screen support</li>
                  <li className="border-b py-2">
                    Interactive/touchscreen support
                  </li>
                  <li className="border-b py-2">Flexible schedule</li>
                  <li className="border-b py-2">Campaign management</li>
                </ul>
              </div>
            </div>
            <div className="shadow-lg hover:shadow-xl rounded-md lg:w-4/12 p-4 mx-6  mb-9">
              <div className="flex flex-col items-center">
                <div className="font-poppins">
                  <ul className="list-disc pl-6">
                    <li className="border-b py-2">Centralize Cloud CMS</li>
                    <li className="border-b py-2">
                      Web and Mobile Apps Management
                    </li>
                    <li className="border-b py-2">Cloud and Local Storage</li>
                    <li className="border-b py-2">Work offline</li>
                    <li className="border-b py-2">Free layout templates</li>
                    <li className="border-b py-2">
                      Custom layout with layout builder
                    </li>
                    <li className="border-b py-2">Multiple screen support</li>
                    <li className="border-b py-2">
                      Interactive/touchscreen support
                    </li>
                    <li className="border-b py-2">Flexible schedule</li>
                    <li className="border-b py-2">Campaign management</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Hardware Section End Here */}

        {/* 3 easy step Section Start Here */}
        <section className="mb-9 mt-9">
          <div className="bg-main-color flex justify-center items-center h-28">
            <h1 className="text-white text-3xl lg:text-4xl font-bold">
              HOW TO START ?
            </h1>
          </div>
          <h2 className="text-black text-3xl lg:text-4xl pt-16 mb-7 font-bold text-center p-3">
            3 EASY STEPS TO PUBLISH YOUR CONTENT​
          </h2>

          <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:px-28">
            <div className="lg:w-4/12 p-4 mx-6 shadow-md rounded-md">
              <div className="flex flex-col items-center pt-6">
                <img
                  loading="lazy"
                  src="./img/mobile-login.png"
                  width="200"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mt-5 text-xl font-bold text-desc-text text-center">
                  Register and Install
                </h3>
                ​
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center">
                  As easy order from any marketplace, our commercial portal will
                  provide real time transaction and easy to deploy to your
                  device within minutes, 24 hours a day, you can register and
                  activate anytime, anywhere in the world
                </p>
              </div>
            </div>
            <div className="lg:w-4/12 p-4 mx-6 shadow-md rounded-md">
              <div className="flex flex-col items-center pt-6">
                <img
                  loading="lazy"
                  src="./img/content.png"
                  width="275"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mt-5 text-xl font-bold text-desc-text text-center">
                  Build Your Content​
                </h3>
                ​
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center">
                  Choose the template or build your own, upload the media and
                  your content ready.
                </p>
              </div>
            </div>
            <div className="lg:w-4/12 p-4 mx-6 shadow-md rounded-md">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/publication.png"
                  width="220"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mt-2 text-xl font-bold text-desc-text text-center">
                  Publish To Your Display​
                </h3>
                ​
              </div>
              <div className="flex flex-col justify-center items-center ">
                <p className="text-center">
                  Publish the content into one display or group of display with
                  ease and lightning fast. With our mobile CMS you can manage it
                  anywhere by your mobile device.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Hardware Section End Here */}

        <section className="mb-10">
          <h2 className="text-black text-3xl lg:text-4xl pt-16 mb-7 font-bold text-center">
            USE CASES
          </h2>
          <div className="flex flex-col items-center lg:flex-row justify-center pt-10">
            <div className="mx-4">
              <img src="./img/usecases.png" width="500" alt="" />
            </div>
            <div>
              <div className="flex mx-4 pt-12 lg:pt-0">
                <button className="text-white font-poppins  bg-main-color  p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Digital Menuboard</a>
                </button>
                <button className="text-white font-poppins  bg-main-color  p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Digital Out Of Home</a>
                </button>
              </div>
              <div className="flex mx-4">
                <button className="text-white font-poppins  bg-main-color mt-3 p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Public Information Display</a>
                </button>
                <button className="text-white font-poppins  bg-main-color mt-3 p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Kiosk</a>
                </button>
              </div>
              <div className="flex mx-4">
                <button className="text-white font-poppins  bg-main-color mt-3 p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  {" "}
                  <a href="#">Emergency Alert Display</a>
                </button>
                <button className="text-white font-poppins  bg-main-color mt-3 p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Videowall</a>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-color  bg-gradient-to-r">
          <div className="flex flex-col justify-center items-center">
            <h2 className="text-white font-bold text-xl lg:text-3xl  uppercase mt-10 text-center">
              Contact Us For More Information
            </h2>
            <p className="text-white font-poppins text-md lg:text-xl  mb-10 text-center mt-2 p-4">
              Our Sales Manager will reach you as soon as we can
            </p>
            <button className="text-main-color font-bold  bg-white p-3 pl-11 pr-11 rounded-md transition .ease-in duration-1000ms hover:text-white hover:bg-orange-dark">
              <a href="#">Contact Us</a>
            </button>
          </div>
        </section>
        <Footer />
      </main>
    </div>
  );
}

export default paneloSign;
